module.exports = __webpack_public_path__ + "static/img/Lucca-Grego.7cdbf76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lucca-Grego.jpg
// module id = eb6n
// module chunks = 0